import is from 'is-lite';
/**
 * Remove properties from an object
 */
export function blacklist(input) {
    var filter = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        filter[_i - 1] = arguments[_i];
    }
    if (!is.plainObject(input)) {
        throw new TypeError('Expected an object');
    }
    var output = {};
    // eslint-disable-next-line no-restricted-syntax
    for (var key in input) {
        /* istanbul ignore else */
        if ({}.hasOwnProperty.call(input, key)) {
            if (!filter.includes(key)) {
                output[key] = input[key];
            }
        }
    }
    return output;
}
/**
 * Get a nested property inside an object or array
 */
export function getNestedProperty(input, path) {
    if ((!is.plainObject(input) && !is.array(input)) || !path) {
        return input;
    }
    var segments = path.split('.');
    var length = segments.length;
    var output = input;
    var _loop_1 = function (idx) {
        var currentSegment = segments[idx];
        var remainingSegments = segments.slice(idx + 1);
        if (currentSegment === '+' && is.array(output) && remainingSegments.length === 1) {
            return { value: output.map(function (d) { return d[remainingSegments.join('.')]; }) };
        }
        try {
            output = output[currentSegment];
        }
        catch (_a) {
            // skip
        }
    };
    for (var idx = 0; idx < length; idx++) {
        var state_1 = _loop_1(idx);
        if (typeof state_1 === "object")
            return state_1.value;
    }
    return output;
}
/**
 * Invert object key and value
 */
export function invertKeys(input) {
    if (!is.plainObject(input)) {
        throw new TypeError('Expected an object');
    }
    var result = {};
    // eslint-disable-next-line no-restricted-syntax
    for (var _i = 0, _a = Object.entries(input); _i < _a.length; _i++) {
        var _b = _a[_i], key = _b[0], value = _b[1];
        result[value] = key;
    }
    return result;
}
/**
 * Set the key as the value
 */
export function keyMirror(input) {
    if (!is.plainObject(input)) {
        throw new TypeError('Expected an object');
    }
    var output = {};
    // eslint-disable-next-line no-restricted-syntax
    for (var key in input) {
        /* istanbul ignore else */
        if (!Object.prototype.hasOwnProperty.call(output, key)) {
            output[key] = key;
        }
    }
    return output;
}
/**
 * Convert an object to an array of objects
 */
export function objectToArray(input, includeOnly) {
    if (!is.plainObject(input)) {
        throw new TypeError('Expected an object');
    }
    return Object.entries(input)
        .filter(function (_a) {
        var value = _a[1];
        return (includeOnly ? typeof value === "" + includeOnly : true);
    }) // eslint-disable-line valid-typeof
        .map(function (_a) {
        var _b;
        var key = _a[0], value = _a[1];
        return (_b = {}, _b[key] = value, _b);
    });
}
/**
 * Stringify a shallow object into a query string
 */
export function queryStringFormat(input, options) {
    if (options === void 0) { options = {}; }
    var _a = options.addPrefix, addPrefix = _a === void 0 ? false : _a, _b = options.encodeValuesOnly, encodeValuesOnly = _b === void 0 ? true : _b, _c = options.encoder, encoder = _c === void 0 ? encodeURIComponent : _c;
    if (!is.plainObject(input)) {
        throw new TypeError("input type isn't supported");
    }
    var isValidInput = Object.values(input).every(function (item) {
        if (is.array(item)) {
            return item.every(function (d) { return is.string(d) || is.number(d); });
        }
        return is.string(item);
    });
    if (!isValidInput) {
        throw new TypeError("input format isn't supported");
    }
    var output = Object.entries(input)
        .map(function (_a) {
        var key = _a[0], value = _a[1];
        var nextKey = encodeValuesOnly ? key : encoder(key);
        var nextValue = is.array(value) ? value.map(encoder).join(',') : encoder("" + value);
        return nextKey + "=" + nextValue;
    })
        .join('&');
    return "" + (addPrefix ? '?' : '') + output;
}
/**
 * Parse a query string
 */
export function queryStringParse(input) {
    var search = input;
    if (input.slice(0, 1) === '?') {
        search = input.slice(1);
    }
    return search.split('&').reduce(function (acc, d) {
        var _a = d.split('='), key = _a[0], value = _a[1];
        acc[decodeURIComponent(key)] = decodeURIComponent(value);
        return acc;
    }, {});
}
/**
 * Sort object keys
 */
export function sortObjectKeys(input) {
    return Object.keys(input)
        .sort()
        .reduce(function (acc, key) {
        acc[key] = input[key];
        return acc;
    }, {});
}
//# sourceMappingURL=objects.js.map